import { FieldLabelProps } from "../FieldLabel";
import { Tooltip } from "../../Tooltip";
import { FieldLabelButton } from "./FieldLabelButton";
import { Icon } from "../../Icon";
import Info from "@servicetitan/hammer-icon/mdi/round/info.svg";
import styles from "../FieldLabel.module.scss";
import { SrOnly } from "../../SrOnly";

/**
 * Internal component for rendering the info icon button with tooltip.
 *
 * @param props - Component props
 * @param props.moreInfo - The content to display in the tooltip
 * @param props.moreInfoId - ID for the visually-hidden description span, used by aria-describedby on the associated input
 */
export const FieldLabelMoreInfoIcon = ({
  moreInfo,
  moreInfoId,
}: {
  moreInfo: FieldLabelProps["moreInfo"];
  moreInfoId?: string;
}) => {
  return (
    <div className={styles["info-container"]}>
      {moreInfoId && <SrOnly id={moreInfoId}>{moreInfo}</SrOnly>}
      <Tooltip
        placement="top"
        offset={5}
        fallbackPlacements={["right", "bottom", "left"]}
      >
        <Tooltip.Trigger className={styles["info-trigger"]}>
          <FieldLabelButton aria-label="More information">
            <Icon svg={Info} />
          </FieldLabelButton>
        </Tooltip.Trigger>
        <Tooltip.Content className={styles["info-content"]}>
          {moreInfo}
        </Tooltip.Content>
      </Tooltip>
    </div>
  );
};
